// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zKfJ","type":"styles_type__3esck","choices":"styles_choices__NuM5X"};